import { render, staticRenderFns } from "./PlanCardPrice.vue?vue&type=template&id=71a68b70&scoped=true"
import script from "./PlanCardPrice.vue?vue&type=script&lang=js"
export * from "./PlanCardPrice.vue?vue&type=script&lang=js"
import style0 from "./PlanCardPrice.vue?vue&type=style&index=0&id=71a68b70&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a68b70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71a68b70')) {
      api.createRecord('71a68b70', component.options)
    } else {
      api.reload('71a68b70', component.options)
    }
    module.hot.accept("./PlanCardPrice.vue?vue&type=template&id=71a68b70&scoped=true", function () {
      api.rerender('71a68b70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Payment/Components/Sections/Plans/PlanCardPrice.vue"
export default component.exports